import TargetedPromoApi from 'client/api/v2/TargetedPromoApi';
import Vue from 'vue';

const initialState = () => ({
  currentPromotedFeatureId: null,
});

const SET_PROMOTED_FEATURE_ID = 'SET_PROMOTED_FEATURE_ID';

const createTargetedPromoModule = () => ({
  namespaced: true,

  state: {
    ...initialState(),
  },

  getters: {
    currentPromotedFeatureId(state) {
      return state.currentPromotedFeatureId;
    },
  },

  actions: {
    async fetchCurrentPromotedFeature({ commit }) {
      const promotedFeatureIdResponse = await TargetedPromoApi.fetch();

      commit(SET_PROMOTED_FEATURE_ID, promotedFeatureIdResponse?.data.results[0]?.featureId);
    },

    async sendAction({ commit, state }, actionType) {
      await TargetedPromoApi.post({
        actionType,
        featureId: state.currentPromotedFeatureId,
      });

      commit(SET_PROMOTED_FEATURE_ID, null);
    },
  },

  mutations: {
    [SET_PROMOTED_FEATURE_ID](state, featureId) {
      Vue.set(state, 'currentPromotedFeatureId', featureId);
    },
  },
});

export default createTargetedPromoModule(TargetedPromoApi);
